import React, { PureComponent } from 'react';
import styled, { css } from 'styled-components';
import { MediumText } from '../../../utils/typography';

type Props = {
  label: string;
  selected?: boolean;
  className?: string;
  onClick: () => void;
};

class ViewButton extends PureComponent<Props> {
  render() {
    const { label, selected, className, onClick } = this.props;
    return (
      <CalHeaderContainer selected={selected} onClick={onClick} className={className}>
        <MediumText strong>{label}</MediumText>
      </CalHeaderContainer>
    );
  }
}

export default ViewButton;

// The chosen view's raised card, on the switch and on it folded into one dropdown (Calendar's
// ResponsiveCalendarViewWrapper), and on the sidebar's Calendar | Task List switch (ViewSwitch). On dark a soft purple
// card with white words, flat: the grey card with purple words and a shadow looked off there (Petr, 2026-10-31).
export const chosenViewBackground = (theme: any) =>
  theme.name === 'dark' ? `color-mix(in srgb, ${theme.primary} 30%, ${theme.background})` : '#ffffff';
export const chosenViewShadow = (theme: any) => (theme.name === 'dark' ? 'none' : '0 1px 2px rgba(63, 78, 97, 0.12)');
export const chosenViewColor = (theme: any) => (theme.name === 'dark' ? '#ffffff' : theme.primary);
// The pale track it sits on (Calendar's CalendarViewWrapper), as the sidebar's Calendar | Task List switch (Petr,
// 2026-10-31: the darker track made them heavy).
export const viewTrackBackground = (theme: any) =>
  `color-mix(in srgb, ${theme.textStrongColor} ${theme.name === 'dark' ? 6 : 4}%, transparent)`;

/**
 * One view on the calendar bar's switch of them (Calendar's CalendarViewWrapper), like the sidebar's Calendar | Task List
 * switch: the chosen one a raised card with purple words, the others plain words, softly tinted purple on hover (Petr,
 * 2026-10-31: they were three outlined boxes).
 */
export const viewSegmentCss = css<{ selected?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  border-radius: 6px;
  box-sizing: border-box;
  cursor: ${props => (props.selected ? 'default' : 'pointer')};
  color: ${props => (props.selected ? chosenViewColor(props.theme) : props.theme.textColor)};
  background: ${props => (props.selected ? chosenViewBackground(props.theme) : 'transparent')};
  box-shadow: ${props => (props.selected ? chosenViewShadow(props.theme) : 'none')};
  transition: background-color 0.15s ease, color 0.15s ease;

  span,
  i {
    color: inherit;
  }

  span {
    font-size: 12px;
    line-height: 15px;
  }

  &:hover {
    ${props =>
      !props.selected &&
      `color: ${props.theme.primary};
       background: color-mix(in srgb, ${props.theme.primary} 12%, transparent);`}
  }
`;

const CalHeaderContainer = styled.div<{ selected?: boolean }>`
  ${viewSegmentCss};
  padding: 0 14px;
`;
